import React, { useState } from 'react';
import { Route, Switch } from 'wouter'
import {
    AppBar,
    Box,
    Button,
    Chip,
    Collapse,
    Container,
    CssBaseline,
    Fab,
    FormControlLabel,
    Hidden,
    IconButton,
    LinearProgress,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Slide,
    TextField,
    Toolbar,
    Typography,
    useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import MuiSwitch from '@mui/material/Switch';
import MenuIcon from '@mui/icons-material/Menu';
import UserAvatar from '../../../containers/UserAvatar';
import { PESONAL_JOURNEY_STEPS, SENIORITIES_LIST, dateAsString, getDaysToNextSubscriptionPay, getInternationalPhone, getNameFromEmail } from '../../../utils/utils';
import { CLOSED_STATUSES } from '../../../redux/actions/filterJobs';
import JSChip from '../../JSChip';
import { Pagination, Skeleton, SpeedDial, SpeedDialAction } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SendIcon from '@mui/icons-material/Send';
import WorkIcon from '@mui/icons-material/Work';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogOutIcon from 'mdi-material-ui/Logout'
import LogInIcon from 'mdi-material-ui/Login'
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import AdminJHApi from "../../../utils/AdminJHApi"
import { JourneyClasses } from '../../../styles/JourneyClasses';
import FieldWithEdit from '../../FieldWithEdit';
import UniqueColor from '../../../containers/UniqueColor';
import SelectAsChip from './SelectAsChip';
import CVCover from './CVCover';
import JourneyTableViewNew from './JourneyTableViewNew';
import { NewJourney } from '../NewJourney';
import Social from './Social';
import DreamJob from './DreamJob';
import JobsFound from './JobsFound';
import JourneyOnbordingFirstSteps from './JourneyOnbordingFirstSteps';
import Profile from './Profile';
import InterviewTracker from './InterviewTracker';
import Newinterviews from '../../Interviews/Newinterviews';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import HistogramC from '../../../containers/HistogramC';
import Pricing from '../Pricing';
import { ReactComponent as JourneyIcon } from '../../../assets/svgs/journey.svg';
import ReactGA from 'react-ga4'
import JourneyNotLogedin from './JourneyNotLogedin';
import ExtraInfoDialog from './ExtraInfoDialog';
import ScheduleMeetingSlots from './ScheduleMeetingSlots';

const useStyles = makeStyles((theme) => ({
    mainPart:{
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        overflow: 'auto', 
        [theme.breakpoints.up('sm')]: {
            flex: 1,
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    adminToolbar:{
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            width: 350, 
            borderRight: '1px solid rgba(0, 0, 0, 0.12)', 
        },
    },
    menuToolbar:{
        backgroundColor: 'white', 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        width: 240, 
        borderRight: '1px solid rgba(0, 0, 0, 0.12)', 
        justifyContent: 'space-between',
        overflow: 'auto',
        [theme.breakpoints.up('sm')]: {
            
        },
    },
    collapseRightRoot: {
        overflow: "hidden",
        transition: "width 0.3s ease",
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            zIndex: 10,
            backgroundColor: '#71717191',
            height: 'calc(100% - 56px)'
        }
    },
    speedDial: {
        position: 'fixed',
        bottom: 16,
        right: 16,
    },
    contactButtonFab: {
        width: 30,
        height: 30,
        minHeight: 25,
        marginRight:16,
        zIndex: 'initial'
    },
    contactButtonIconFab: {
        height: 15
    },
    mainContainer: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }
    }
}));

function CollapseRight({ open, width = 250, children }) {
    const classes = useStyles();

    const finalWidth = (window.innerWidth <= 768) ? window.innerWidth : width
  
    return (
        <div
            className={classes.collapseRightRoot}
            style={{
                width: open ? finalWidth : 0
            }}
        >
            {children}
        </div>
    );
}

function JourneyHeader(props){
    const { journeyData, showedStep, disabled, isAdmin, cycles, freezeHistory, signedDate } = props;
    const completed = journeyData.completed || {}
    const classes = useStyles();
    const theme = useTheme();

    const adminLists = props.adminLists

    const CSManagers = adminLists.managers || []
    const statuses = adminLists.statuses || []
    const plans = adminLists.plans || []

    const [moreInfo, setMoreInfo] = useState(false);
    const [extraInfoDialog, setExtraInfoDialog] = useState({});

    const internationalPhone = getInternationalPhone(journeyData.phone || '')

    //const waLink = `https://api.whatsapp.com/send/?type=phone_number&phone=`+internationalPhone
    const waLink = 'https://wa.me/'+internationalPhone

    const URLparts = window.location.pathname.split('/');
    const currRoute = (URLparts[1] || '').toLowerCase()
    const minimalView = (currRoute === 'interviews')
    const show = (currRoute !== 'interview-recaps') && (isAdmin || (showedStep > 0) || (completed.dataChecked && completed.uploadCV && completed.firstMeeting))

    const beginServiceDate = journeyData.beginServiceDate || journeyData.dateCreated

    const now = new Date();
    const oneDay = 1000 * 60 * 60 * 24;

    let daysInFreeze = 0
    freezeHistory.forEach(element => {
        if (element.start>=beginServiceDate){
            daysInFreeze += Math.round((new Date(element.end||now) - new Date(element.start))/oneDay)
        }
    });

    const daysInServiceEndDate = signedDate?new Date(signedDate):now

    //const daysSincelLastPublish = journeyData.lastPublishDate?Math.round((now - new Date(journeyData.lastPublishDate))/oneDay):0
    const daysSinceFirstPartSent = journeyData.firstPartSent?Math.round((now - new Date(journeyData.firstPartSent))/oneDay):0
    const daysInService = (beginServiceDate?Math.round((daysInServiceEndDate - new Date(beginServiceDate))/oneDay):0) - daysInFreeze

    const numberOfCycles = cycles? cycles.length:0

    const handleSetManager = newManage => {
        let paramsToPass = {data:{csManager:newManage}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    };

    const handleSetStatus = newStatus => {
        if (newStatus === 'freezed'){
            setExtraInfoDialog({type: 'freezed', status: newStatus})
        } else {
            let paramsToPass = {data:{status: newStatus}}

            if (isAdmin){
                paramsToPass.userId = props.userId
            }

            props.preServerCall()

            AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
                props.postServerCall(null, response)
            }, (error) => {
                console.log(error)
                props.postServerCall()
            })
        }
    }

    const handleSetPlan = newPlan => {
        let paramsToPass = {data:{plan: newPlan}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const handleSetSeniority = newSeniority => {
        let paramsToPass = {data:{seniorityLevel:newSeniority}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const changeCyclesLimit = cyclesLimit => {
        let paramsToPass = {data:{cyclesLimit}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const changeJourneyPhone = (newPhone) => {
        let paramsToPass = {data:{phone:newPhone}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const updateStatusWithExtra = newData => {
        let paramsToPass = {data:newData}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
            setExtraInfoDialog({})
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const changeFreezeCheckDate = freezeCheckDate => {
        let paramsToPass = {data:{freezeCheckDate, freezeCheckEmailSent: false}}

        if (isAdmin){
            paramsToPass.userId = props.userId
        }

        props.preServerCall()

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            props.postServerCall(null, response)
        }, (error) => {
            console.log(error)
            props.postServerCall()
        })
    }

    const journeyClasses = JourneyClasses()

    return (
        <>
            <ExtraInfoDialog extraInfoDialog={extraInfoDialog} onClose={()=>setExtraInfoDialog()} handleSave={updateStatusWithExtra}/>
            {show&&<Paper style={{marginBottom: 8, height: 'initial'}} className={journeyClasses.block} elevation={1}>
                <div>
                    <div className="jobTitleSection">
                        <div className="jobTitle" style={{color:'#222', width: '100%', fontSize: 24}}>
                            {journeyData.title || ''}
                        </div>
                    </div>
                    <div style={{position: 'relative'}}>
                        <UserAvatar positionAbsolute 
                            firstName={journeyData.first_name} 
                            lastName={journeyData.last_name} 
                            avatarSrc={''} 
                            backgroundColor={journeyData.card_color} />
                        <div className={"jobInfoSectionInner ltr"} style={{minHeight: 42}}>
                            <div className="jobCompany" style={{color:'rgba(0, 0, 0, 0.54)', fontWeight:'bold', display:'flex', alignItems: 'center'}}>
                                {(journeyData.first_name || '') + ' ' + (journeyData.last_name || '')}
                                {isAdmin&&minimalView&&<div style={{marginLeft: 16}}>
                                    <Chip onClick={()=>setExtraInfoDialog({type: 'meetingLink'})} size="small" label="Meeting Link" color="primary" style={{marginRight:8}}/>
                                    <UniqueColor value={journeyData.status||''} defColor={theme.palette.primary.main}>
                                        <SelectAsChip value={journeyData.status} onChange={handleSetStatus} list={statuses} emptyLabel='No Status' disabled={disabled} style={{marginleft:8}} noEdit={!isAdmin}/>
                                    </UniqueColor>
                                </div>}
                            </div>
                            {!minimalView && <>
                            {(journeyData.phone)&&<div className="jobLocation" style={{color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>{journeyData.phone || ''}</div>}
                            <div className="jobLocation" style={{textTransform: 'lowercase', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>{journeyData.email || ''}  <span style={{color: 'blue', cursor: 'pointer'}} onClick={()=>setMoreInfo(!moreInfo)}>{moreInfo?'less':'more'} info</span></div>
                            {moreInfo&&<>
                                <div className="jobLocation" style={{textTransform: 'capitalize', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>
                                    {daysInService} days in service ({dateAsString(new Date(beginServiceDate))})
                                </div>
                                {(daysInFreeze>0)&&<div className="jobLocation" style={{textTransform: 'capitalize', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>
                                    {daysInFreeze} days in freeze
                                </div>}
                                {/*(journeyData.lastPublishDate!==undefined)&&<div className="jobLocation" style={{textTransform: 'capitalize', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>
                                    Published {daysSincelLastPublish} days ago
                                </div>*/}
                                <FieldWithEdit value={journeyData.cyclesLimit||''} changeValue={changeCyclesLimit} noEdit={!isAdmin}>
                                    <span className="jobLocation" style={{textTransform: 'capitalize', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>
                                        Cycles: {numberOfCycles} {journeyData.cyclesLimit&&<> / {journeyData.cyclesLimit}</>}{(journeyData.cyclesLimit && numberOfCycles === journeyData.cyclesLimit)&&<span style={{color:'#f44336',fontWeight:'bold'}}> Last Cycle</span>}
                                    </span>
                                </FieldWithEdit>
                                {(journeyData.firstPartSent!==undefined)&&<div className="jobLocation" style={{textTransform: 'capitalize', color:'rgba(0, 0, 0, 0.54)', lineHeight: 1.5}}>
                                    Publication started {daysSinceFirstPartSent} days ago
                                </div>}
                                
                            </>}
                            <div style={{marginTop:4}}>
                                <FieldWithEdit value={journeyData.phone||''} changeValue={changeJourneyPhone}>
                                    {(internationalPhone)?<>
                                        <Fab size="small" className={classes.contactButtonFab} href={'tel:'+internationalPhone} color="primary" target='_blank' rel="noopener noreferrer">
                                            <PhoneIcon className={classes.contactButtonIconFab} fontSize="small" />
                                        </Fab>
                                        <Fab size="small" className={classes.contactButtonFab} href={waLink} color="primary" target='_blank' rel="noopener noreferrer">
                                            <WhatsAppIcon className={classes.contactButtonIconFab} fontSize="small" />
                                        </Fab>
                                    </>:
                                    <span>{(journeyData.phone)?'Invalid Phone': 'No Phone'}</span>}
                                </FieldWithEdit>
                            </div>
                            </>}
                        </div>
                    </div>
                </div>
                {isAdmin&&!minimalView&&<div style={{marginTop:8}}>
                    <Chip onClick={()=>setExtraInfoDialog({type: 'meetingLink'})} size="small" label="Meeting Link" color="primary" style={{marginRight:8, marginTop:8}}/>
                    <UniqueColor value={journeyData.csManager||''} defColor={theme.palette.primary.main}>
                        <SelectAsChip value={journeyData.csManager} onChange={handleSetManager} list={CSManagers} emptyLabel='No Manager' labelFunc={getNameFromEmail} disabled={disabled} style={{marginRight:8, marginTop:8}} noEdit={!isAdmin}/>
                    </UniqueColor>
                    <UniqueColor value={journeyData.status||''} defColor={theme.palette.primary.main}>
                        <SelectAsChip value={journeyData.status} onChange={handleSetStatus} list={statuses} emptyLabel='No Status' disabled={disabled} style={{marginRight:8, marginTop:8}} noEdit={!isAdmin}/>
                    </UniqueColor>
                    <UniqueColor value={journeyData.plan||''} defColor={theme.palette.primary.main}>
                        <SelectAsChip value={journeyData.plan} onChange={handleSetPlan} list={plans} emptyLabel='No Plan' disabled={disabled} style={{marginRight:8, marginTop:8}} noEdit={!isAdmin}/>
                    </UniqueColor>
                    <UniqueColor value={journeyData.seniorityLevel||''} defColor={theme.palette.primary.main}>
                        <SelectAsChip value={journeyData.seniorityLevel} onChange={handleSetSeniority} list={SENIORITIES_LIST} emptyLabel='No Seniority' disabled={disabled} style={{marginRight:8, marginTop:8}}/>
                    </UniqueColor>
                    {completed.afterPayment&&<Chip size="small" label="New OnBoarding" color="primary" style={{marginRight:8, marginTop:8}}/>}
                </div>}

                {(isAdmin&&!minimalView&&journeyData.status==='freezed')&&<Box mt={2}>
                    <strong>End freeze check: </strong>
                    <FieldWithEdit value={journeyData.freezeCheckDate||''} changeValue={changeFreezeCheckDate} fieldInputType="date">
                        <span>{journeyData.freezeCheckDate}</span>
                    </FieldWithEdit>
                    {journeyData.freezeCheckDate&&<Typography>{journeyData.freezeCheckEmailSent?'Sent':'Not sent'}</Typography>}
                </Box>}
            </Paper>}
        </>
    )
}

function SearchTalents(props){
    const searchFields = props.searchFields || {}

    const [newSearch, setNewSearch] = useState({...searchFields});

    const getValue = name => {
        if (newSearch[name] !== undefined){
            return newSearch[name]
        } else {
            return searchFields[name] || ''
        }
    }

    const handleChangeField = e => {
        setNewSearch({...newSearch,[e.target.name]: e.target.value})
    };

    const handleSearch = () => {
        props.setSearchFields({...newSearch})
        props.setUserId()
    }

    return (
        <div style={{display: 'flex'}}>
            <TextField
                name='queryString'
                type="search"
                value={getValue('queryString')}
                onChange={handleChangeField}
                placeholder="Email / Name / Title"
                variant="outlined"
                style={{marginRight:8, width: '100%'}}
                size='small'
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        handleSearch();
                    }
                }}
            />
            {/*<TextField
                name='email'
                type="search"
                value={getValue('email')}
                onChange={handleChangeField}
                placeholder='Email'
                variant="outlined"
                style={{marginRight:8}}
                size='small'
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        handleSearch();
                    }
                }}
            />*/}
            <Button variant="contained" color="primary" onClick={handleSearch} aria-label="Search" size='small'>
                Search
            </Button>
        </div>
    )
}

function FilterTalents(props){
    const talentsNoFilter = props.talentsNoFilter || []
    const filter = props.filter || {}

    //const [filterTab, setFilterTab] = useState(0);
    const [filterBy, setFilterBy] = useState('manager');

    const filtersBy = ['manager','status', 'plan', 'seniority', /*'step', 'publish step',*/ 'need attention'/*, 'other'*//*, 'title category'*/];

    //const filterBy = filtersBy[filterTab]

    const possiblesAll = {
        'manager': {options: ['No Manager'], checkField: 'csManager'},
        'status': {options: ['No Status', 'signed', 'freezed', 'out of service', 'unsubscribed', 'published', 'new talent', 'unused service']},
        'plan': {options: ['No Plan'], checkField: 'plan'},
        'seniority': {options: SENIORITIES_LIST},
        'need attention': {options: [/*'last publish more than 14 days',*/ 'waiting for approval', '7th day first part sent', 'frozen for more than two months']},
    }

    const filtered = filter[filterBy] || []
    const count = filter.count || 0

    const possiblesObject = possiblesAll[filterBy] || {}

    let possibles = possiblesObject.options || []
    if (possiblesObject.checkField){
        let uniqueValues = [...new Set(talentsNoFilter.map(item => item[possiblesObject.checkField]))].filter(item=>(item))

        if (filterBy === 'manager'){
            uniqueValues = uniqueValues.map(item=>getNameFromEmail(item))
        }
        
        possibles = [...possibles, ...uniqueValues]
    }

    const handleClearAllFiltered = () => {
        props.setFilter({'manager':[],'status':[], 'plan':[], 'seniority':[], 'need attention':[]})
    }

    const handleClearFiltered = () => {
        props.setFilter({...filter, [filterBy]:[], count: count - filtered.length})
    }

    const handleToggleFilter = option => {
        let newFiltered
        let newCount = count
        if (filtered.includes(option)){
            newFiltered = filtered.filter(item=>(item!==option))
            newCount--
        } else {
            newFiltered = [...filtered, option]
            newCount++
        }

        if ((filterBy === 'status' && CLOSED_STATUSES.includes(option)) || ((filterBy === 'need attention' && option === 'frozen for more than two months' ))){
            props.setUserId()
        }

        props.setFilter({...filter, [filterBy]:newFiltered, count:newCount})
    }

    return (
        <div className='filter-journey'>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: 4, marginRight: 4}}>
                    {(count === 0) ?
                    <span>Filter by:</span> :
                    <Chip onDelete={handleClearAllFiltered} label={count} className="clearFilter" style={{bottom: 'initial'}}/>
                    }
                </div>
                <div>
                    {filtersBy.map(filterByItem => {
                        return (
                            <Button 
                                key={filterByItem}
                                variant={(filterByItem === filterBy)?'contained' : 'outlined'}
                                color={(filter[filterByItem] && filter[filterByItem].length >0)?'secondary':'primary'}
                                //color='primary'
                                //color='secondary'
                                size='small' 
                                style={{textTransform: 'capitalize', margin: 4}}
                                onClick={()=>setFilterBy(filterByItem)}
                            >{filterByItem}</Button>
                        )
                    })} 
                    {/*<Tabs 
                        value={filterTab} 
                        onChange={(event, value) => {setFilterTab(value)}}
                        //variant="scrollable"
                        scrollButtons="off"
                        classes={{ indicator: (filter[filterBy] && filter[filterBy].length >0) ? "filtered tabIndicator" : "tabIndicator" }}
                    >
                    {filtersBy.map(filterByItem=>{
                        return (
                            <Tab key={filterByItem} 
                                label={filterByItem} 
                                //value={index} 
                                className={(filter[filterByItem] && filter[filterByItem].length >0) ? "filtered filterTab" : "filterTab"}
                                classes={{ selected: "selected"}}
                            />
                        )
                    })} 
                    </Tabs>*/}
                </div>
            </div>
            {(possibles.length > 0) &&
            <div style={{marginTop: 8}}>
                <JSChip onClick={handleClearFiltered} selected={(filtered.length === 0)}
                >ALL</JSChip>
                    {possibles.map(possible => 
                    <JSChip 
                        key={possible} 
                        onClick={() => handleToggleFilter(possible)} 
                        selected={(filtered.includes(possible))}
                        //rect={FILTER_COMPANY_TYPES.includes(possible)}
                    >
                        {possible}
                    </JSChip>)}
            </div>}
        </div>
    )
}

function TalentListItem(props) {
    const { jobHuntUser, fetchingData, setUserId, userId } = props;

    const selected = (jobHuntUser.userId === userId)

    const personal_journey = jobHuntUser

    const avatarSrc = jobHuntUser.avatarSrc || 'https://jobswipe.co/assets/images/def_avatar.jpg'//jobHuntUser.avatar_url || undefined

    //const {badge, badgeDesc} = getJobBadge(jobHuntUser, 'profile')

    const now = new Date();
    const oneDay = 1000 * 60 * 60 * 24;
    const daysSincelLastPublish = personal_journey.lastPublishDate?Math.round((now - new Date(personal_journey.lastPublishDate))/oneDay):0
    //const daysSinceFirstDaySent = personal_journey.firstPartSent?Math.round((now - new Date(personal_journey.firstPartSent))/oneDay):0

    const lastCycle = (personal_journey.numberOfCycles === personal_journey.cyclesLimit)

    const daysToNextPay = getDaysToNextSubscriptionPay(personal_journey.subscriptionStart);

    return (
        <li className={selected ? 'cl selected':'cl'}  onClick={()=>setUserId(jobHuntUser.userId)}>
            <div>
                <UserAvatar
                        positionAbsolute
                        firstName={jobHuntUser.first_name} 
                        lastName={jobHuntUser.last_name} 
                        avatarSrc={avatarSrc} 
                        backgroundColor={jobHuntUser.card_color}
                        margin 
                        fetchingData={fetchingData}/>
                <div className="clInfo">
                    <div className="clTitle">
                        {(fetchingData)?<Skeleton variant="text" width={"90%"} animation="wave"/>:<>{personal_journey.title || ''}</>}
                    </div>
                    <div className="clCompany" style={{fontWeight:'bold'}}>
                        {(fetchingData)?<Skeleton variant="text" width={"60%"} animation="wave"/>:
                        <>{personal_journey.first_name || jobHuntUser.first_name || ''} {personal_journey.last_name || jobHuntUser.last_name || ''}</>}
                    </div>
                    <div className="clLocation" style={{textTransform: 'lowercase'}}>
                        {(fetchingData)?<Skeleton variant="text" width={"70%"} animation="wave"/>:<>{personal_journey.email || jobHuntUser.email || ''}</>}
                    </div>
                    {(!fetchingData && personal_journey.currentStep!==undefined)&&<div className="clCompany" style={{textTransform: 'capitalize'}}>
                        Step: {PESONAL_JOURNEY_STEPS[personal_journey.currentStep||0]}
                    </div>}
                    {(!fetchingData && personal_journey.status!==undefined)&&<div className="clLocation" style={{textTransform: 'capitalize'}}>
                        Status: {personal_journey.status}
                    </div>}
                    {(!fetchingData && personal_journey.plan!==undefined)&&<div className="clCompany" style={{textTransform: 'capitalize'}}>
                        Plan: {personal_journey.plan}
                    </div>}
                    {(!fetchingData && personal_journey.lastPublishDate!==undefined)&&<div className="clLocation" style={{textTransform: 'capitalize'}}>
                        Published {daysSincelLastPublish} days ago
                    </div>}
                    {(!fetchingData && daysToNextPay!==undefined && !personal_journey.isSubscriptionClosed 
                        && personal_journey.subscriptionStart!==undefined && personal_journey.subscriptionId!==undefined)
                        && daysToNextPay <= 7
                        &&<div className="clCompany" style={{textTransform: 'capitalize'}}>
                        Next Pay: <span style={{color:'#f44336',fontWeight:'bold'}}>In {daysToNextPay} days</span>
                    </div>}
                    {(!fetchingData && personal_journey.numberOfCycles!==0)&&<div className="clCompany" style={{textTransform: 'capitalize'}}>
                        <span>Cycles: {personal_journey.numberOfCycles}</span>{personal_journey.cyclesLimit&&<> / {personal_journey.cyclesLimit}{personal_journey.cyclesLimitExtra&&<> + {personal_journey.cyclesLimitExtra}</>}</>}{lastCycle&&<span style={{color:'#f44336',fontWeight:'bold'}}> Last Cycle</span>}
                    </div>}
                    {/*(badge)&&<div className="clJobMoreInfoSection">
                        <div className="clDateCreated jobMoreInfo ltr">
                            <span style={{color:"#ea7600"}} className="jobMoreInfoText">{badge}</span>&nbsp;
                            <span className="jobMoreInfoText">{badgeDesc}</span>
                        </div>
                    </div>*/}
                </div>
            </div>
        </li>
    )
}

function AdminToolbar(props) {
    const talents = props.talents || []
    const fetchingData = props.isLoadingClients || false

    const ROWS_PER_PAGE = 100

    const [page, setPage] = useState(1);

    const pagesCount = Math.ceil(talents.length / ROWS_PER_PAGE)
    const pagedData = talents.slice((page - 1) * ROWS_PER_PAGE, page * ROWS_PER_PAGE)

    //const journeyClasses = JourneyClasses()

    return (
        <>
            {props.isLoadingClients&&<LinearProgress />}
            <Hidden smUp implementation="css">
                {!fetchingData&&<div style={{backgroundColor: 'white', padding: 16, paddingBottom: 0}}>
                    <SearchTalents {...props}/>
                </div>}
            </Hidden>
            {!fetchingData&&<FilterTalents {...props}/>}
            {fetchingData?<></>:<>
                <div className="histTitle" style={{borderBottom: '1px solid rgba(0, 0, 0, .10)'}}>{talents.length} Clients</div>
                <ul className="cards" style={{flex: 1, overflow: 'auto'}}>
                    {pagedData.map(talent=>{
                        return (
                            <TalentListItem key={talent.userId} jobHuntUser={talent} setUserId={props.setUserId} userId={props.userId} fetchingData={fetchingData}/>
                        )
                    })}
                </ul>
                {(pagesCount>1)&&<div style={{padding: '16px 8px', display: 'flex', justifyContent: 'center'}}>
                    <Pagination count={pagesCount} color="primary" page={page} onChange={(event, value) => setPage(value)}/>
                </div>}
            </>}
        </>
    )
}

export default function JourneyViewTwo(props) {
    const { history, isAuthed, isActiveJHUser, journeyData, setJourneyData, showedStep, disabled, userInfo, isAdmin } = props;

    const view = (window.innerWidth <= 768)?'MOBILE':'DESKTOP'

    const [showAdminToolbar, setShowAdminToolbar] = useState((view==='DESKTOP'));
    const [showJourneyHeader, setShowJourneyHeader] = useState(true);
    const [showMenu, setShowMenu] = useState((view==='DESKTOP'));
    const [showSupport, setShowSupport] = useState(false);
    const [logoLloaded, setLogoLoaded] = useState(false);

    const URLparts = window.location.pathname.split('/');
    const currRoute = (URLparts[1] || '').toLowerCase()
    const avatarSrc = (userInfo && userInfo.avatar && userInfo.avatar.url) ? userInfo.avatar.url : undefined
    const completed = journeyData.completed || {}

    const handleChangeRoute = location => {
        if (view === 'MOBILE'){
            setShowMenu(false);
        }

        ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `menu_click_${location||'home'}`})
        props.changeRoute(location)
    };

    const handleLogin = () => {
        if (view === 'MOBILE'){
            setShowMenu(false);
        }
        ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `menu_click_login`})
        props.handleLogin()
    }

    const handleLogOut = () => {
        if (view === 'MOBILE'){
            setShowMenu(false);
        }
        ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `menu_click_logout`})
        props.handleLogOut()
    }

    const fullWidth = (
        (currRoute === '' && (journeyData._id && (showedStep > 0 || (completed.dataChecked && completed.uploadCV && completed.firstMeeting)))) || 
        (currRoute === 'interviews')
    )

    const mainContatinerStyle = (currRoute === 'jobs')?{padding: 0}:(!isActiveJHUser && (currRoute === 'publication')?{maxWidth: 'initial'}:{})

    const classes = useStyles();

    return (
        <div style={{display:'flex', height: '100vh', flexDirection: 'column'}}>
            <CssBaseline />
            <AppBar color="default" style={{position: 'initial'}}>
                <Toolbar>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Hidden smUp implementation="css">
                            <IconButton
                                //color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                //className={classes.menuButton}
                                onClick={()=>setShowMenu(!showMenu)}
                                size="large">
                                {showMenu?<CloseIcon/> : <MenuIcon />}
                            </IconButton>
                        </Hidden>
                        <Hidden smDown implementation="css">
                            <img onLoad={() => setLogoLoaded(true)} style={{ height: 40 }} src="https://jobhunt.co.il/wp-content/themes/jobboard/assets/images/jobhunt-ntl.png" alt="סוכן טאלנטים אישי לעולם ההיי-טק" />
                            {logoLloaded&&<JourneyIcon style={{height: 40, width: 'inherit', marginLeft: 8}}/>}
                        </Hidden>
                        {isAdmin&&<FormControlLabel style={{color: '#202020', marginLeft: 8}}
                            control={<MuiSwitch
                                checked={showAdminToolbar}
                                onChange={()=>{setShowAdminToolbar(!showAdminToolbar)}}
                                color="primary"
                            />}
                            label="Admin Toolbars"
                        />}
                        <Hidden smDown implementation="css">
                            {isAdmin&&<SearchTalents {...props}/>}
                        </Hidden>
                    </div>
                    <div style={{flex:1}}></div>
                    <Hidden smDown implementation="css">
                        {isAuthed&&<div onClick={()=>{if(!isAdmin){props.changeRoute('profile')}}} style={{cursor: 'pointer', marginRight: 12}}>
                            <Typography style={{fontWeight: 500}} color='textPrimary'>{userInfo.first_name} {userInfo.last_name}</Typography>
                            {!isAdmin&&journeyData._id&&<Typography color='textSecondary'>{journeyData.title}</Typography>}
                        </div>}
                    </Hidden>
                    {isAuthed&&<div style={{cursor: 'pointer'}} onClick={()=>{if(!isAdmin){props.changeRoute('profile')}}}><UserAvatar firstName={userInfo.first_name} 
                        lastName={userInfo.last_name} 
                        avatarSrc={avatarSrc} 
                        backgroundColor={userInfo.card_color}
                        className="avatar" 
                    /></div>}
                </Toolbar>
            </AppBar>
            <div style={{flex: 1, display: 'flex', overflow: 'auto'}}>
                {isAdmin&&<CollapseRight open={showAdminToolbar} width={350}>
                    <div className={classes.adminToolbar}>
                        <AdminToolbar {...props} showAdminToolbar={showAdminToolbar}/>
                    </div>
                </CollapseRight>}
                <CollapseRight open={showMenu} width={240}>
                    <div className={classes.menuToolbar}>
                    {isAuthed ? <> 
                        <List dense>
                            {journeyData._id && <>
                            <ListItem button onClick={()=>handleChangeRoute('')} selected={(currRoute === '')}>
                                <ListItemIcon>
                                    <HomeIcon />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItem>
                            {/*<ListItem button onClick={()=>handleChangeRoute('social')}>
                                <ListItemIcon>
                                    <InsertDriveFileIcon />
                                </ListItemIcon>
                                <ListItemText primary="Social" />
                            </ListItem>*/}
                            <ListItem button onClick={()=>handleChangeRoute('files')} selected={(currRoute === 'files')}>
                                <ListItemIcon>
                                    <InsertDriveFileIcon />
                                </ListItemIcon>
                                <ListItemText primary="Files" />
                            </ListItem>
                            <ListItem button onClick={()=>handleChangeRoute('interviews')} selected={(currRoute === 'interviews')}>
                                <ListItemIcon>
                                    <EventAvailableIcon />
                                </ListItemIcon>
                                <ListItemText primary="Interview Tracker" />
                            </ListItem>
                            <ListItem button onClick={()=>handleChangeRoute('publication')} selected={(currRoute === 'publication')}>
                                <ListItemIcon>
                                    <SendIcon />
                                </ListItemIcon>
                                <ListItemText primary={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        CV Exposure
                                        {!isActiveJHUser && (
                                        <Chip
                                            label="Pro"
                                            size="small"
                                            style={{
                                            backgroundColor: '#FFD700',
                                            color: '#000',
                                            fontWeight: 600
                                            }}
                                        />
                                        )}
                                    </div>
                                }/>
                            </ListItem>
                            <ListItem button onClick={()=>handleChangeRoute('dream-job')} selected={(currRoute === 'dream-job')}>
                                <ListItemIcon>
                                    <WorkIcon />
                                </ListItemIcon>
                                <ListItemText primary="Dream Job" />
                            </ListItem>
                            <ListItem button onClick={()=>handleChangeRoute('jobs-offers')} selected={(currRoute === 'jobs-offers')}>
                                <ListItemIcon>
                                    <WorkIcon />
                                </ListItemIcon>
                                <ListItemText primary="Jobs & Offers" />
                            </ListItem>
                            </>}
                        </List> 

                        <List dense>
                            <ListItem button onClick={()=>handleChangeRoute('interview-recaps')} selected={(currRoute === 'interview-recaps')}>
                                <ListItemIcon>
                                    <AssignmentTurnedInIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Interview Recaps" />
                            </ListItem>
                            <ListItem button onClick={()=>handleChangeRoute('jobs')} selected={(currRoute === 'jobs')}>
                                <ListItemIcon>
                                    <AssignmentTurnedInIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Jobs" />
                            </ListItem>
                            {/*<ListItem button component="a" href="https://jobswipe.co/jobs" target="_blank">
                                <ListItemIcon>
                                    <WorkIcon />
                                </ListItemIcon>
                                <ListItemText primary="Jobs" />
                            </ListItem>*/}
                            <ListItem button onClick={()=>ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `menu_click_interview_guidelines`})} component="a" href="https://docs.google.com/document/d/1Sj-popwPsFWbLN_ZSGGupztx4HI5vnCWnDk35VrhD-8/edit?tab=t.0" target="_blank">
                                <ListItemIcon>
                                    <DescriptionIcon />
                                </ListItemIcon>
                                <ListItemText primary="Interview Guidelines" />
                            </ListItem>
                        </List> 

                        <List dense>
                            <ListItem button onClick={()=>handleChangeRoute('profile')} selected={(currRoute === 'profile')}>
                                <ListItemIcon>
                                    <AccountCircleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Profile" />
                            </ListItem>
                            <ListItem button onClick={handleLogOut}>
                                <ListItemIcon>
                                    <LogOutIcon />
                                </ListItemIcon>
                                <ListItemText primary="Log Out" />
                            </ListItem>
                        </List> 
                    </>:
                    <List>
                        <ListItem button onClick={handleLogin}>
                            <ListItemIcon>
                                <LogInIcon />
                            </ListItemIcon>
                            <ListItemText primary="Log In" />
                        </ListItem>
                    </List>}
                    </div>
                </CollapseRight>
                <main className={classes.mainPart} style={(journeyData._id && isAuthed)?{}:{backgroundColor:'white'}}>
                    {((journeyData._id && isAuthed)|| (currRoute === 'schedule_meeting')) ? <Container className={classes.mainContainer} maxWidth={fullWidth?false:'lg'} style={mainContatinerStyle}>   
                        {props.isLoadingClients || props.isLoadingAll ?<>{(!props.isLoadingClients || props.isLoadingAll)&&<LinearProgress />}</>:<>
                        {(isActiveJHUser || isAdmin) && (currRoute !== 'jobs' && currRoute !== 'schedule_meeting' && currRoute !== 'saveditems' && !(journeyData.plan === 'files' && currRoute === 'publication'))&&<div>
                            <Collapse in={showJourneyHeader} timeout="auto" unmountOnExit> 
                                <JourneyHeader {...props} />
                            </Collapse>
                        </div>}
                            <Switch>
                                {/*<Route path="/publications-steps" render={(cProps) => <CVCover {...cProps} {...props}/>} />*/}
                                <Route path="/files">
                                    <CVCover {...props} isNew/>
                                </Route>
                                <Route path="/interviews">
                                    <> 
                                        <JourneyTableViewNew {...props} setShowJourneyHeader={setShowJourneyHeader}/>
                                        {/*(window.innerWidth <= 768)?
                                            <Interviews {...cProps} {...props}/>:
                                            <InterviewTracker {...cProps} {...props}/>
                                        */}
                                    </>
                                </Route>
                                {/*<Route path="/publication" render={(cProps) =><Publication {...cProps} {...props}/>} />*/}
                                <Route path="/publication">
                                    <>
                                        {(journeyData.plan === 'files')?<div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                            <Typography variant='h5' style={{ margin: '16px 0' }}>Your plan doesn’t include this feature</Typography>
                                        </div>:
                                        <>
                                            {isActiveJHUser?<Paper className={classes.block} elevation={1}><NewJourney {...props} /></Paper>:
                                            <Pricing/>}
                                        </>}
                                    </>
                                </Route>
                                <Route path="/social"><Social {...props}/></Route>
                                <Route path="/dream-job"><DreamJob {...props}/></Route>
                                <Route path="/jobs-offers"><JobsFound {...props}/></Route>

                                <Route path="/profile"><Profile {...props}/></Route>
                                <Route path="/interview-recaps"><Newinterviews isAdmin={isAdmin}/></Route>

                                <Route path="/jobs/:job">
                                    {(params) => <HistogramC match={{ params }} histogramType={'jobs'}/>}
                                </Route>
                                <Route path="/jobs">
                                    {(params) => <HistogramC match={{ params }} histogramType={'jobs'}/>}
                                </Route>
                                <Route path="/saveditems">
                                    {(params) => <HistogramC match={{ params }} histogramType={'saveditems'}/>}
                                </Route>

                                <Route path="/schedule_meeting">
                                    <ScheduleMeetingSlots {...props}/>
                                </Route>
                                <Route>
                                    <>
                                        {(journeyData._id && (!isActiveJHUser || showedStep > 0 || (completed.dataChecked && completed.uploadCV && completed.firstMeeting))) ? 
                                            <InterviewTracker {...props}/>:
                                            <JourneyOnbordingFirstSteps {...props} journeyData={journeyData} disabled={disabled} setJourneyData={setJourneyData} />}
                                    </>
                                </Route>
                                {/*<Route path="/" render={(cProps) => <>
                                    {(journeyData._id && (showedStep > 0 || (completed.dataChecked && completed.uploadCV && completed.firstMeeting))) ? 
                                        <Paper className={classes.block} elevation={1}><NewJourney {...cProps} {...props} /></Paper>:
                                        <JourneyOnbordingFirstSteps journeyData={journeyData} disabled={disabled} setJourneyData={setJourneyData} />}
                                </>} />*/}
                            </Switch>
                        </>}
                    </Container>:
                    <JourneyNotLogedin handleLogin={handleLogin}/>}
                    {/*isAuthed && !isActiveJHUser && !isAdmin && <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <Typography variant='h5' style={{ margin: '16px 0' }}>This feature will be available soon </Typography>
                        <Button rel="noopener noreferrer" href='https://jobhunt.co.il/?career&sourse=journey' color='primary' variant='contained'>לבדיקת התאמה</Button>
                            </div>*/}
                    <Slide direction="up" in={!isAdmin || (!showAdminToolbar && (view==='DESKTOP' || (view==='MOBILE' && !showMenu)))} mountOnEnter unmountOnExit>
                        <SpeedDial
                            ariaLabel="Support"
                            className={classes.speedDial}
                            //hidden={hidden}
                            icon={<ContactSupportIcon />}
                            onClose={()=>setShowSupport(false)}
                            onOpen={()=>setShowSupport(true)}
                            open={showSupport}
                            direction='up'
                        >
                            <SpeedDialAction
                                href={window.OFFICE_LINK}
                                target="_blank" rel="noopener noreferrer" 
                                icon={<WhatsAppIcon />}
                                tooltipTitle='WhatsApp'
                            />
                            <SpeedDialAction
                                href="mailto:aneli@jobhunt.co.il,office@jobhunt.co.il"
                                target="_blank" rel="noopener noreferrer" 
                                icon={<EmailIcon />}
                                tooltipTitle='Email'
                            />
                        </SpeedDial>
                    </Slide>
                </main>
            </div>
        </div>
    );
}